module.exports = __webpack_public_path__ + "img/gb.8c7f7718.webp";